export const patternMatchFactory = (numericOnly, alphaOnly, exceptions) => {
	let baseMatchRegEx = new RegExp("^[a-zA-Z0-9]+$");

	if (exceptions) {
		let escapedExceptions = exceptions.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");

		if (alphaOnly) {
			baseFilterRegEx = new RegExp("[^" + escapedExceptions + "a-zA-Z]", "g");
		} else if (numericOnly) {
			baseFilterRegEx = new RegExp("[^" + escapedExceptions + "0-9]", "g");
		} else {
			baseFilterRegEx = new RegExp("[^" + escapedExceptions + "a-zA-Z0-9]", "g");
		}
	} else {
		if (alphaOnly) {
			baseFilterRegEx = new RegExp("[^a-zA-Z]", "g");
		} else if (numericOnly) {
			baseFilterRegEx = new RegExp("[^0-9]", "g");
		}
	}

	return (stringToFilter) => {
		let filteredString = stringToFilter.replace(baseFilterRegEx, "").trim();

		return filteredString;
	};
};

export const patternFilterFactory = (numericOnly, alphaOnly, exceptions) => {
	let baseFilterRegEx = new RegExp("[^a-zA-Z0-9]", "g");

	if (exceptions) {
		let escapedExceptions = exceptions.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");

		if (alphaOnly) {
			baseFilterRegEx = new RegExp("[^" + escapedExceptions + "a-zA-Z]", "g");
		} else if (numericOnly) {
			baseFilterRegEx = new RegExp("[^" + escapedExceptions + "0-9]", "g");
		} else {
			baseFilterRegEx = new RegExp("[^" + escapedExceptions + "a-zA-Z0-9]", "g");
		}
	} else {
		if (alphaOnly) {
			baseFilterRegEx = new RegExp("[^a-zA-Z]", "g");
		} else if (numericOnly) {
			baseFilterRegEx = new RegExp("[^0-9]", "g");
		}
	}

	return (stringToFilter) => {
		let filteredString = stringToFilter.replace(baseFilterRegEx, "").trim();

		return filteredString;
	};
};
